/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Browse_TitleInputs */

const en_help_browse_title = /** @type {(inputs: Help_Browse_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse by topic`)
};

const pl_help_browse_title = /** @type {(inputs: Help_Browse_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tematy`)
};

/**
* | output |
* | --- |
* | "Browse by topic" |
*
* @param {Help_Browse_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_browse_title = /** @type {((inputs?: Help_Browse_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Browse_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_browse_title(inputs)
	return en_help_browse_title(inputs)
});